"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;
exports.parseAndCheckHttpResponse = parseAndCheckHttpResponse;
exports.parseHeaders = parseHeaders;
exports.parseJsonBody = parseJsonBody;
exports.readMultipartBody = readMultipartBody;
var _tslib = require("apollo-stack-hubspot/internal/tslib/tslib");
var _responseIterator = require("apollo-stack-hubspot/@apollo/client/link/http/responseIterator");
var _index = require("apollo-stack-hubspot/@apollo/client/link/utils/index");
var _index2 = require("apollo-stack-hubspot/@apollo/client/errors/index");
var _incrementalResult = require("apollo-stack-hubspot/@apollo/client/utilities/common/incrementalResult");
var hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, nextValue) {
  return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
    var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
    var _b, _c;
    var _d;
    return (0, _tslib.__generator)(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (TextDecoder === undefined) {
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          }
          decoder = new TextDecoder("utf-8");
          contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
          delimiter = "boundary=";
          boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
          boundary = "\r\n--".concat(boundaryVal);
          buffer = "";
          iterator = (0, _responseIterator.responseIterator)(response);
          running = true;
          _e.label = 1;
        case 1:
          if (!running) return [3 /*break*/, 3];
          return [4 /*yield*/, iterator.next()];
        case 2:
          _a = _e.sent(), value = _a.value, done = _a.done;
          chunk = typeof value === "string" ? value : decoder.decode(value);
          searchFrom = buffer.length - boundary.length + 1;
          running = !done;
          buffer += chunk;
          bi = buffer.indexOf(boundary, searchFrom);
          while (bi > -1) {
            message = void 0;
            _b = [buffer.slice(0, bi), buffer.slice(bi + boundary.length)], message = _b[0], buffer = _b[1];
            i = message.indexOf("\r\n\r\n");
            headers = parseHeaders(message.slice(0, i));
            contentType_1 = headers["content-type"];
            if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) {
              throw new Error("Unsupported patch content type: application/json is required.");
            }
            body = message.slice(i);
            if (body) {
              result = parseJsonBody(response, body);
              if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                if ((0, _incrementalResult.isApolloPayloadResult)(result)) {
                  next = {};
                  if ("payload" in result) {
                    if (Object.keys(result).length === 1 && result.payload === null) {
                      return [2 /*return*/];
                    }
                    next = (0, _tslib.__assign)({}, result.payload);
                  }
                  if ("errors" in result) {
                    next = (0, _tslib.__assign)((0, _tslib.__assign)({}, next), {
                      extensions: (0, _tslib.__assign)((0, _tslib.__assign)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[_index2.PROTOCOL_ERRORS_SYMBOL] = result.errors, _c))
                    });
                  }
                  nextValue(next);
                } else {
                  // for the last chunk with only `hasNext: false`
                  // we don't need to call observer.next as there is no data/errors
                  nextValue(result);
                }
              } else if (
              // If the chunk contains only a "hasNext: false", we can call
              // observer.complete() immediately.
              Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) {
                return [2 /*return*/];
              }
            }
            bi = buffer.indexOf(boundary);
          }
          return [3 /*break*/, 1];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}
function parseHeaders(headerText) {
  var headersInit = {};
  headerText.split("\n").forEach(function (line) {
    var i = line.indexOf(":");
    if (i > -1) {
      // normalize headers to lowercase
      var name_1 = line.slice(0, i).trim().toLowerCase();
      var value = line.slice(i + 1).trim();
      headersInit[name_1] = value;
    }
  });
  return headersInit;
}
function parseJsonBody(response, bodyText) {
  if (response.status >= 300) {
    // Network error
    var getResult = function getResult() {
      try {
        return JSON.parse(bodyText);
      } catch (err) {
        return bodyText;
      }
    };
    (0, _index.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
  }
  try {
    return JSON.parse(bodyText);
  } catch (err) {
    var parseError = err;
    parseError.name = "ServerParseError";
    parseError.response = response;
    parseError.statusCode = response.status;
    parseError.bodyText = bodyText;
    throw parseError;
  }
}
function handleError(err, observer) {
  // if it is a network error, BUT there is graphql result info fire
  // the next observer before calling error this gives apollo-client
  // (and react-apollo) the `graphqlErrors` and `networkErrors` to
  // pass to UI this should only happen if we *also* have data as
  // part of the response key per the spec
  if (err.result && err.result.errors && err.result.data) {
    // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
  }
  observer.error(err);
}
function parseAndCheckHttpResponse(operations) {
  return function (response) {
    return response.text().then(function (bodyText) {
      return parseJsonBody(response, bodyText);
    }).then(function (result) {
      if (!Array.isArray(result) && !hasOwnProperty.call(result, "data") && !hasOwnProperty.call(result, "errors")) {
        // Data error
        (0, _index.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function (op) {
          return op.operationName;
        }) : operations.operationName, "'."));
      }
      return result;
    });
  };
}